import React, { useState, useEffect } from "react";
import axiosClient from "../../../axios-client.js";
import icGenCard from '../../assets/svg/steps/card/ic-gen-card.svg';

const GenericInfos = ({ idLang, templateSelected, updateFormData, onFileChange, inputValueName }) => {
    const [template, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fileContent, setFileContent] = useState('');
    const [displayText, setDisplayText] = useState(`Upload your PDF file`);
    const [selectedFile, setSelectedFile] = useState(null);
    const [inputfileName, setInputName] = useState(null)


    // Define state to manage input values
    const [inputValues, setInputValues] = useState({});

    useEffect(() => {
        if (idLang) {
            getTemplates();
        }

    }, [idLang]);


    const getTemplates = () => {
        setLoading(true);
        axiosClient
            .get(`/templates?language_id=${idLang}&is_broadcast=0`)
            .then(({ data }) => {
                setLoading(false);
                setTemplates(data.data);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const templateWithId = template.find((item) => item.id === templateSelected);

    const handleInputChange = (variableName, value) => {
        // Construct the data object with the variable name and its value
        if (inputfileName == null) {
            const selectedTemplate = template.find((item) => item.id === templateSelected);
            if (selectedTemplate && selectedTemplate.file_data) {
                setInputName(selectedTemplate.file_data.variable);
                inputValueName(selectedTemplate.file_data.variable)

            } else {
                setInputName(null);
            }
        }
        const data = {
            [variableName]: value,
        };
        updateFormData(data);
        setInputValues({
            ...inputValues,
            [variableName]: value,
        });
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const maxFileSize = 4 * 1024 * 1024;
        const reader = new FileReader();

        if (file && file.size > maxFileSize) {
            alert('File size exceeds the maximum limit of 4 MB.');
            event.target.value = null;
            return;
        }

        reader.onload = (e) => {
            const content = e.target.result;
            setFileContent(content);
            setDisplayText(file.name);
        };

        setSelectedFile(file)
        reader.readAsText(file);
        onFileChange(file);

    };

    const handleUpload = () => {
        // Implement your upload logic here
        if (fileContent) {
            // You can send the file content to your server or perform any other desired action.
            console.log('File content:', fileContent);
            // Call the callback function with the selected file and variable name
            onFileChange(fileContent, variableName);
        } else {
            alert('Please select a file first.');
        }
    };

    // Check if both variables and global_variables are empty
    const isVariablesEmpty = templateWithId && templateWithId.variables.length === 0;
    const isGlobalVariablesEmpty = templateWithId && templateWithId.global_variables.length === 0;

    return (
        <>
            {(isVariablesEmpty && isGlobalVariablesEmpty) ? null : (
                <>
                    <div id='content' className='divider my-5'></div>
                    <img className='my-3 d-flex mx-auto ic-card-msg' src={icGenCard} alt='' srcSet='' />
                    <h1 className='text-center title my-4'>Your Content</h1>
                    <div className='divider my-5'></div>
                </>
            )}

            <div className="col-md-12 p-0">
                <div className="col-md-12 p-0">
                    {template.map((templateItem) => (
                        <div key={templateItem.id} className="container">
                            <>
                                {templateWithId && templateWithId.id === templateItem.id && (
                                    <>
                                        <div className="row justify-content-start align-items-start col-md-10 px-2">
                                            {templateItem.variables.map((variable) => (
                                                <div className="col-md-6 my-3" key={variable.variable}>
                                                    <label className="my-1 fw-bold">{variable.name}</label>
                                                    <input
                                                        required
                                                        name={variable.variable}
                                                        placeholder={variable.name}
                                                        type="text"
                                                        className="form-control rounded-pill"
                                                        value={inputValues[variable.variable] || ''}
                                                        onChange={(e) =>
                                                            handleInputChange(variable.variable, e.target.value)
                                                        }
                                                    />
                                                    <span className={`${variable.variable} d-none text-danger`}>
                                                        {variable.name} is required
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="row justify-content-start align-items-start col-md-10 px-2">
                                            {templateItem.global_variables.map((item) => (
                                                <div className="col-md-6 my-3" key={item.variable}>
                                                    <label className="my-1 fw-bold">{item.name}</label>
                                                    <input
                                                        required
                                                        name={item.variable}
                                                        placeholder={item.name}
                                                        type="text"
                                                        className="form-control rounded-pill"
                                                        value={inputValues[item.variable] || ""}
                                                        onChange={(e) =>
                                                            handleInputChange(item.variable, e.target.value)
                                                        }
                                                    />
                                                    <span className={`${item.variable} d-none text-danger`}>
                                                        {item.name} is required
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                        {templateItem.has_file ? (
                                            <>
                                                <div className="row justify-content-start align-items-start col-md-10 px-2 mt-3">
                                                    <label className="my-3 fw-bold">{templateItem.file_data.name}</label>
                                                    <div className="col-md-6">
                                                        <div className='input-group input-bg d-flex rounded-pill '>
                                                            <div className='d-flex'>
                                                                <div className='w-100 form-control input-bg file'>
                                                                    <label htmlFor='fileInput' className='fileInputLabel'>
                                                                        {/* {displayText} */}
                                                                        {/* {console.log(templateItem)} */}
                                                                        Upload {templateItem.file_data.name}
                                                                    </label>
                                                                    <input
                                                                        type='file'
                                                                        id='fileInput'
                                                                        name={templateItem.file_data.variable}
                                                                        accept='.png, .jpeg, .jpg, .pdf'
                                                                        className='bg-transparent fileInput file w-100'
                                                                        onChange={handleFileUpload}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <label role='button' htmlFor='fileInput' className='fileInputLabel ms-auto rounded-pill btn btn-success m-2 text-white justify-content-center align-self-center d-flex'>
                                                                Upload
                                                            </label>
                                                            {/* <button onClick={handleUpload} className='ms-auto rounded-pill mx-1 btn btn-success m-2'>
                                                                Upload
                                                            </button> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                            </>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default GenericInfos;
